import { getTenant } from "../helpers/getTenant"
import { supabase } from "../lib/supabase"
import { getUserId } from "../helpers/getUserId"
import { KINDS } from "../lib/constants"

type CommentLikePayload = {
  liked: boolean
  commentId: string
}

export const commentLike = async ({ commentId, liked }: CommentLikePayload) => {
  const userId = await getUserId()

  if (!userId) return

  const record = {
    kind: KINDS.COMMENT_LIKE,
    tenant: getTenant(),
    user_uuid: userId,
    parent_id: commentId
  }

  if (liked) {
    return supabase
      .from("db")
      .delete()
      .eq("kind", KINDS.COMMENT_LIKE)
      .eq("parent_id", commentId)
      .eq("user_uuid", userId) as unknown as void
  } else {
    return supabase.from("db").insert(record) as unknown as void
  }
}
